import * as React from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router';
import { Container } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import MainAppBar from './MainAppBar';
import LeftLandscapeBar from './LeftLandscapeBar';
import themePrimary from '../../styles/themePrimary';

const useStyles = makeStyles({
    landscapeGrid: {
        display: 'grid',
        gridTemplateColumns: 'calc(100vw *.3) calc(100vw * .7)',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    landscapeGridContainer: {
        display: 'flex',
        height: '100vh',
    },
    rootPortrait: {
        overflow: 'scroll',
        padding: '0',
        backgroundColor: themePrimary.palette.primary.contrastText + ' !important',
    },
    rootPortraitEmailReceipt: {
        padding: '0',
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: themePrimary.palette.primary.contrastText + ' !important',
        border: '1px solid #E0E0E0'
    },
    rootPortraitEmailReceiptMobile: {
        padding: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: themePrimary.palette.primary.contrastText + ' !important',
    },
    rootLandscape: {
        maxWidth: '5000px',
        padding: '0',
        backgroundColor: themePrimary.palette.primary.contrastText + ' !important',
    },
});

export default (props: { children?: React.ReactNode }) => {
    const classes = useStyles();
    const history = useHistory();

    return (<React.Fragment>
        {history.location.pathname.includes('/receipt') &&
            <Container className={clsx({
                [classes.rootPortraitEmailReceiptMobile]: isMobile,
                [classes.rootPortraitEmailReceipt]: !isMobile,
            })}>
                <MainAppBar />
                {props.children}
            </Container>
        }

        {!history.location.pathname.includes('/receipt') &&
            <Container className={classes.rootPortrait}>
                <MainAppBar />
                {props.children}
            </Container>
        }

        
    </React.Fragment>);
};
